<script setup lang="ts">
import PageGlobal from '../views/PageGlobal.vue'
</script>

<template>
  <PageGlobal />
</template>
